import React from 'react';
import { IRating } from '@/creditflowresearch/domain/vo/IRating';
import ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = (tranche: ITranch, rating: IRating) => (
  tranche.ratings[rating.id]
    ? tranche.ratings[rating.id][0].abbreviation
    : '-'
);

export interface IRatingAgencyCellProps {
  tranche: ITranch,
  rating: IRating,
  rowIndex: number,
}

const RatingAgencyCell = ({
  rowIndex,
  tranche,
  rating,
}: IRatingAgencyCellProps) => (
  <BodyCell
    name="RatingAgencyCell"
    className={ alignStyles.alignCenter }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ () => getCell(tranche, rating) }
  />
);

export default RatingAgencyCell;
